exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable .btn-sm {\r\n  font-size: 0.635rem !important;\r\n  line-height: 1 !important;\r\n  display: flex;\r\n  align-items: baseline;\n}\n.on-print {\r\n  display: none;\r\n  text-align: center;\n}\n@media print {\n.on-print {\r\n    display: block;\r\n    text-align: center !important;\n}\n}\r\n", ""]);

// exports
